import React from 'react';
import { useIntl } from 'react-intl';

import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import { Zap } from 'lucide-react';
import { UserType } from 'types/shared/user-type.enum';
import { UserFeatures } from 'types/user-features.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const FeedManagementTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'feedManagement.navigation';
  const {
    account: { currentUser },
  } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: currentUser?.userFeatures.includes(UserFeatures.Nutritionist),
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.listBestMixFeeds` }),
          to: '/feed-management/bestmix-feeds',
        },
        {
          hasAccess: currentUser?.userFeatures.includes(UserFeatures.Nutritionist),
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.listManualFeeds` }),
          to: '/feed-management/manual-feeds',
        },
        {
          hasAccess: currentUser?.userFeatures.includes(UserFeatures.Nutritionist),
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.listCustomers` }),
          to: '/feed-management/customers',
        },
        {
          hasAccess: currentUser?.userType === UserType.SuperUser,
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.listPlants` }),
          to: '/feed-management/plants',
        },
        {
          hasAccess: currentUser?.userType === UserType.SuperUser,
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.listNutrients` }),
          to: '/feed-management/nutrients',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Zap size={25} color={'white'} />}
    />
  );
};

export default React.memo(FeedManagementTabsHeader);
